import React, { useState, useMemo, createContext, useReducer } from 'react';
import Select from 'react-select';
import { defaultStyle } from '../selectStyle';
import { Dropdown, ValueContainer, DropdownIndicator, Control, Option, MenuList } from '../Components/Parts';
import { useTranslation } from '@hooks';

const selectStyles = {
    ...defaultStyle,
    container: (provided, state) => ({
        ...provided,
        minWidth: '11.5rem',
        // maxWidth: '14rem',
    }),
    control: provided => ({
        ...provided,
        // minWidth: '11.5rem',
        // maxWidth: '14rem',
        margin: 8,
    }),
    menu: () => ({ boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)' }),
    menuList: provided => ({
        ...provided,
        // maxWidth: '17rem',
    }),
};

export const SearchableSelectContext = createContext();

const SearchableSelect = ({
    className,
    data = [],
    selected = [],
    title,
    labelKey = 'label',
    valueKey = 'value',
    onChange,
    name,
    DropdownControlComponent,
    MenuListComponent,
    OptionComponent,
    ControlComponent,
    keepSortOrder = false,
}) => {
    const [state] = useReducer(null, { title, labelKey, valueKey });
    const [isOpen, setIsOpen] = useState(false);
    const t = useTranslation('Search');
    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };
    const getOptionValue = option => option[valueKey];
    const getOptionLabel = option => option[labelKey];
    //const filterOption = ({ label }, string) => ~label.toLowerCase().indexOf(string.toLowerCase());
    const selectedOptions = useMemo(() => {
        if (keepSortOrder) {
            return (selected || []).reduce((acc, curr) => {
                const selectedData = data.find(option => option[valueKey] === curr);
                if (selectedData) {
                    acc.push(selectedData);
                }
                return acc;
            }, []);
        }
        return data.reduce((acc, curr) => {
            if ((selected || []).includes(curr[valueKey])) {
                acc.push(curr);
            }
            return acc;
        }, []);
    }, [data, selected, valueKey, keepSortOrder]);

    return (
        <SearchableSelectContext.Provider value={state}>
            <Dropdown
                className={className}
                isOpen={isOpen}
                onClose={toggleOpen}
                target={
                    DropdownControlComponent ? (
                        <DropdownControlComponent onClick={toggleOpen} />
                    ) : (
                        <ValueContainer
                            title={title}
                            labelKey={labelKey}
                            isOpen={isOpen}
                            selected={selectedOptions}
                            onClick={toggleOpen}
                            options={data}
                        />
                    )
                }
            >
                <Select
                    isMulti
                    // autoFocus
                    backspaceRemovesValue={false}
                    components={{
                        DropdownIndicator,
                        IndicatorSeparator: null,
                        MenuList: MenuListComponent ? MenuListComponent : MenuList,
                        Option: OptionComponent ? OptionComponent : Option,
                        Control: ControlComponent ? ControlComponent : Control,
                    }}
                    controlShouldRenderValue={false}
                    // hideSelectedOptions={false}
                    isClearable={false}
                    menuIsOpen
                    onChange={onChange}
                    options={data}
                    placeholder={t('Search')}
                    noOptionsMessage={() => t('No options')}
                    styles={selectStyles}
                    tabSelectsValue={false}
                    getOptionValue={getOptionValue}
                    getOptionLabel={getOptionLabel}
                    value={selectedOptions}
                    //filterOption={filterOption}
                    name={name}
                />
            </Dropdown>
        </SearchableSelectContext.Provider>
    );
};

export default SearchableSelect;
